export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.bonian_provider_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
